import ServerError from "@zenith/assets/illustrations/ServerError";
import React from "react";

interface ServerErrorHandlerProps {
  illustration?: React.ReactNode;
  errorTitle?: string;
  errorMessage?: string;
}

const ServerErrorHandler = ({
  errorTitle,
  errorMessage,
  illustration,
}: ServerErrorHandlerProps) => {
  return (
    <div className="flex min-h-[50vh] w-full flex-col items-center justify-center space-y-2">
      {illustration ? illustration : <ServerError />}
      <div className="w-1/2 text-center font-medium text-neutral-700">{errorTitle}</div>
      <div className="text-center text-sm text-neutral-600">{errorMessage}</div>
    </div>
  );
};

export default ServerErrorHandler;
